import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useCheckPermissions from 'hooks/auth/useCheckPermission';

function AppRoute({ component, path, permission, fallbackComponent, ...rest }) {
  const { userCheckPermission } = useCheckPermissions();

  const show = permission ? userCheckPermission(permission) : true;

  if (show) return <Route {...rest} component={component} path={path} />;

  if (fallbackComponent)
    return <Route {...rest} component={fallbackComponent} />;

  return <Redirect {...rest} to="/" />;
}

export default AppRoute;
